import React from 'react'
import LgyHero from './LgyHero'
import LGYGraphicListSection from './LgyGraphicListSection'

const LgyAnonymousLandingPage = () =>
  <div className='lgy-anonymous-landing-page'>
    <LgyHero />
    <LGYGraphicListSection />
  </div>

export default LgyAnonymousLandingPage